import { __awaiter, __extends, __generator } from "tslib";
import Model from './model';
var VideoSession = (function (_super) {
    __extends(VideoSession, _super);
    function VideoSession() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoSession.prototype.enterQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var videoSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.post("/videos/" + this.data.id + "/enter")];
                    case 1:
                        videoSession = (_a.sent()).data.data.videoSession;
                        return [2, this.createSelf(videoSession)];
                }
            });
        });
    };
    VideoSession.prototype.leaveQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var videoSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.post("/videos/" + this.data.id + "/leave")];
                    case 1:
                        videoSession = (_a.sent()).data.data.videoSession;
                        return [2, this.createSelf(videoSession)];
                }
            });
        });
    };
    VideoSession.prototype.notify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var videoSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.post("/videos/" + this.data.id + "/notify")];
                    case 1:
                        videoSession = (_a.sent()).data.data.videoSession;
                        return [2, this.createSelf(videoSession)];
                }
            });
        });
    };
    VideoSession.prototype.setInReview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var videoSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.post("/videos/" + this.data.id + "/review")];
                    case 1:
                        videoSession = (_a.sent()).data.data.videoSession;
                        return [2, this.createSelf(videoSession)];
                }
            });
        });
    };
    VideoSession.prototype.sendHeartbeat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var videoSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.get("/videos/" + this.data.id + "/heartbeat")];
                    case 1:
                        videoSession = (_a.sent()).data.data.videoSession;
                        return [2, this.createSelf(videoSession)];
                }
            });
        });
    };
    return VideoSession;
}(Model));
export default VideoSession;
//# sourceMappingURL=video-session.js.map